import { IMG } from "@/data/images";
import { BookButton } from "./BookButton";
import { Reveal } from "./Reveal";

// Full-bleed closing call-to-action used across pages.
export const CTASection = ({
  eyebrow = "Ready when you are",
  title = "Secure your Colosseum tickets today",
  text = "Skip the queues, compare every option and lock in your time slot. Tickets are booked through our trusted partner GetYourGuide.",
  image = IMG.nightWarm,
  bookLabel = "Browse tickets on GetYourGuide",
  testId = "cta-section",
}) => (
  <section
    data-testid={testId}
    className="relative overflow-hidden rounded-[2rem] bg-charcoal text-white"
  >
    <div className="absolute inset-0">
      <img
        src={image}
        alt=""
        loading="lazy"
        className="h-full w-full object-cover opacity-40"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-charcoal via-charcoal/85 to-charcoal/40" />
    </div>
    <Reveal className="relative px-7 py-16 sm:px-12 md:px-16 md:py-24 max-w-2xl">
      <span className="text-xs md:text-sm uppercase tracking-[0.22em] font-semibold text-gold-light">
        {eyebrow}
      </span>
      <h2 className="mt-4 font-serif text-3xl md:text-4xl lg:text-5xl font-medium leading-tight text-balance">
        {title}
      </h2>
      <p className="mt-5 text-base md:text-lg font-light text-white/75 leading-relaxed">
        {text}
      </p>
      <div className="mt-8">
        <BookButton label={bookLabel} size="lg" testId={`${testId}-book`} />
      </div>
    </Reveal>
  </section>
);

export default CTASection;
